/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { PayoutDetailPageService } from '@pages/PayoutDetailPage/services';

const getSrv = () => {
  return vappContainer.get<PayoutDetailPageService>(
    PayoutDetailPageService.displayName
  );
};

export const sendReminder = async (context: any, event: any) => {
  const currentState = 'SEND_REMINDER';
  const method = 'sendReminder';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      // const _getArgs = () => {
      //   let _args: any = {};
      //   if (event?.type === "START") {
      //     _args = context["GET_PAYOUT_CONTENT"];
      //   }
      //   if (event?.type === "TRIGGER_REFRESH") {
      //     _args = {
      //       offset: event?.offset,
      //       size: event?.size,
      //       criteria: event?.criteria,
      //     };
      //   }
      //   console.log("getPageContent args =>", _args);
      //   return _args;
      // };
      const srv = getSrv();
      // const shelves = await srv.agent.getEventDetailProps();
      const shelves = await srv.agent.getStaticPayoutDetailContentSync(
        event?.payout
      );
      if (shelves) {
        return resolve({
          key: 'SEND_REMINDER_SUCCESS',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'SEND_REMINDER_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'SEND_REMINDER_FAILED',
        value: err?.message,
      });
    }
  });
};
